import { useEffect, useRef } from 'react';

const useScrollOptimization = () => {
  const isScrollingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);
  const rafRef = useRef(null);

  // (removed unused optimizedScrollHandler to satisfy CI lint)

  useEffect(() => {
    // Simplified scroll handler to prevent memory leaks
    const handleScrollSimple = () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      
      rafRef.current = requestAnimationFrame(() => {
        if (!isScrollingRef.current) {
          isScrollingRef.current = true;
          document.body.classList.add('is-scrolling');
        }

        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
        }

        scrollTimeoutRef.current = setTimeout(() => {
          isScrollingRef.current = false;
          document.body.classList.remove('is-scrolling');
        }, 150);
      });
    };

    // Add scroll listener with passive for better performance
    window.addEventListener('scroll', handleScrollSimple, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScrollSimple);
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
      
      // Cleanup CSS class
      document.body.classList.remove('is-scrolling');
    };
  }, []); // Empty dependency array to prevent re-creation

  return {
    isScrolling: isScrollingRef.current
  };
};

export default useScrollOptimization; 